import { CASH_PAYMENT_METHOD_LABELS, CASH_STATUS_LABELS } from './constants';
import { LEGACY_TERMS } from '../terms/legacyTerms';
export function cashFlowLabel(flow, terms = LEGACY_TERMS) {
    var _a;
    return (_a = terms.cash.flowLabel[flow]) !== null && _a !== void 0 ? _a : flow;
}
export function cashFlowShortLabel(flow, terms = LEGACY_TERMS) {
    var _a;
    return (_a = terms.cash.flowShortLabel[flow]) !== null && _a !== void 0 ? _a : flow;
}
export function cashStatusLabel(status) {
    var _a;
    return (_a = CASH_STATUS_LABELS[status]) !== null && _a !== void 0 ? _a : status;
}
export function cashPaymentMethodLabel(method) {
    var _a;
    return (_a = CASH_PAYMENT_METHOD_LABELS[method]) !== null && _a !== void 0 ? _a : method;
}
export function cashFlowTone(flow) {
    if (flow === 'admin_super_agent')
        return 'blue';
    if (flow === 'super_agent_agent')
        return 'default';
    if (flow === 'shop_player_deposit')
        return 'green';
    if (flow === 'shop_player_redemption')
        return 'amber';
    return 'muted';
}
export function cashStatusTone(status) {
    if (status === 'paid_full')
        return 'green';
    if (status === 'pending_payment' || status === 'partially_paid')
        return 'amber';
    if (status === 'cancelled')
        return 'red';
    return 'muted';
}
export const cashToneClassName = {
    default: 'bg-slate-100 text-slate-700 border-slate-200',
    blue: 'bg-blue-100 text-blue-800 border-blue-200',
    green: 'bg-green-100 text-green-700 border-green-200',
    amber: 'bg-amber-100 text-amber-800 border-amber-200',
    red: 'bg-red-100 text-red-700 border-red-200',
    muted: 'bg-muted text-muted-foreground border-border',
};
